import React, { useEffect, useRef, useState } from "react";
import { Divider, getIcons, MenuItems, PageMenuItem } from "../../Constant/Constant";
import BackArrows from "../../Form/BackArrow/BackArrows";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation, useNavigate } from "react-router-dom";
import { getBasePathByUserRole } from "../../../utils/roleRoutes";

import { MdKeyboardArrowRight } from "react-icons/md";
import { FaFacebook } from "react-icons/fa6";

import leadSourceService from "../../Services/LeadSourceService";
import WebhooksService from "../../Services/WebhooksService";
import CustomHeading from "../../common/CustomHeading";
import LeadSourceDropdown from "../../Form/LeadTable/LeadSourceDropdown";
import { fetchAndCacheLeadSources, getLeadSourcesFromCache } from "../../hooks/useLeadSourceCache";
import axios from "axios";
import { baseUrl } from '../../../config/clientsConfig'

const ConnectedPage = () => {
  const location = useLocation();
  const Icon = getIcons();
  const menuRef = useRef(null);
  const [pagesData, setPagesData] = useState([]);
  const [loadingPages, setLoadingPages] = useState({}); // Track loading state for each page

  // Helper function to get lead source name from localStorage using leadSourceId
  const getLeadSourceNameById = (leadSourceId) => {
    if (!leadSourceId) return null;
    
    try {
      const cachedLeadSources = getLeadSourcesFromCache();
      const leadSource = cachedLeadSources?.find(source => source.id === leadSourceId);
      return leadSource ? leadSource.name : null;
    } catch (error) {
      console.error("Error getting lead source name:", error);
      return null;
    }
  };

  const [leadSource, setLeadSource] = useState([]); // Remove hardcoded values

  const navigate = useNavigate();
  const [visibleMenu, setVisibleMenu] = useState(false);

  const accountData = location.state?.accountData;
  console.log("Account Data:", accountData);
  const selectedMedia = location.state?.selectedMedia || null;
  const defaultLeadSource = location.state?.defaultLeadSource || null;
  const approvedRequestId = location.state?.approvedRequestId || null;

  // Apply default lead source if coming from approval flow
  // useEffect(() => {
  //   if (defaultLeadSource && approvedRequestId) {
  //     // Update the first page without a lead source to use the default one
  //     setPagesData(prevPages => {
  //       const firstPageWithoutSource = prevPages.find(page => !page.leadSource);
  //       if (firstPageWithoutSource) {
  //         return prevPages.map(page => 
  //           page.id === firstPageWithoutSource.id 
  //             ? { ...page, leadSource: defaultLeadSource }
  //             : page
  //         );
  //       }
  //       return prevPages;
  //     });
  //   }
  // }, [defaultLeadSource, approvedRequestId]);

  useEffect(() => {
    const fetchPages = async () => {
      try {
        // Fetch pages data from WebhooksService
        const response = await axios.get(`${baseUrl}/accounts/${accountData?.accountId}/pages`);

        const pages = response.data || [];  // Ensure pages is an array
        const updatedPages = pages.map(page => ({
          id: page.pageId,  // Changed from docId to id
          pageId: page.pageId,  // Keep pageId for consistency
          pageName: page.pageName,
          isSubscribed: page.isSubscribed,
          leadSourceId: page?.leadSourceId  // Only store the leadSourceId
        }));
        setPagesData(updatedPages);
      } catch (error) {
        console.error("Failed to fetch pages:", error);
      }
    };
    
    // Fetch and cache lead sources for the dropdown
    const initializeLeadSources = async () => {
      try {
        await fetchAndCacheLeadSources();
      } catch (error) {
        console.error("Failed to cache lead sources:", error);
      }
    };

    fetchPages();
    initializeLeadSources();
  }, []);

  const handleBack = () => {
    navigate(-1);
  };

  const handleMenuToggle = () => {
    setVisibleMenu(!visibleMenu);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setVisibleMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleFormPageList = (page) => {
    const path = getBasePathByUserRole();

    navigate(`${path}/web-hooks-form-list`, {
      state: {
        pageName: page.pageName,
        pageId: page.id,
        isSubscribed: page.isSubscribed,
        leadSourceId: page.leadSourceId,
        leadSourceName: getLeadSourceNameById(page.leadSourceId),
      },
    });
  };

  // Helper function to handle lead source updates
  const handleLeadSourceUpdate = async (page, selectedItem) => {
    try {
      // Get current user ID from localStorage
      const userData = JSON.parse(localStorage.getItem("userData"));
      const userId = userData?.user?.uid;

      // API call to update lead source
      await axios.put(`${baseUrl}/accounts/${accountData?.accountId}/pages/${page.pageId}/lead-source`, {
        leadSourceId: selectedItem.id,
        modifiedBy: userId
      });

      // Update local state
      const updatedPages = pagesData.map((p) =>
        p.id === page.id
          ? {
              ...p,
              leadSourceId: selectedItem.id,
            }
          : p
      );
      setPagesData(updatedPages);

      // Show success toast
      toast.success("Lead source updated successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (error) {
      console.error("Failed to update lead source:", error);
      toast.error("Failed to update lead source. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const handleToggle = async (pageId) => {
    // Set loading state for this specific page
    setLoadingPages(prev => ({ ...prev, [pageId]: true }));
    
    try {
      const targetPage = pagesData.find((p) => p.pageId === pageId);
      const isCurrentlySubscribed = targetPage?.isSubscribed;
      
      const updatedPages = pagesData.map((page) =>
        page.pageId === pageId
          ? { ...page, isSubscribed: !page.isSubscribed }
          : page
      );

      // Get current user ID from localStorage
      const userData = JSON.parse(localStorage.getItem("userData"));
      const userId = userData?.user?.uid;

      await axios.put(`${baseUrl}/accounts/${accountData?.accountId}/pages/${pageId}/subscription`, {
        subscribe: !pagesData.find((p) => p.pageId === pageId).isSubscribed,
        modifiedBy: userId
      });
      
      setPagesData(updatedPages);

      // Show success toast based on subscription status
      if (isCurrentlySubscribed) {
        toast.success("Page unsubscribed successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } else {
        toast.success("Page subscribed successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }

      //const targetPage = updatedPages.find((p) => p.id === pageId);  // Changed from p.docId to p.id
      // await WebhooksService.updateSubscriptionStatus({
      //   docId: pageId,
      //   isSubscribed: targetPage.isSubscribed,
      // });
    } catch (error) {
      console.error("Failed to toggle subscription:", error);
      
      // Revert the optimistic update on error
      const revertedPages = pagesData.map((page) =>
        page.pageId === pageId
          ? { ...page, isSubscribed: !page.isSubscribed }
          : page
      );
      setPagesData(revertedPages);
      
      // Show error toast
      toast.error("Failed to update subscription. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      // Remove loading state for this page
      setLoadingPages(prev => {
        const newState = { ...prev };
        delete newState[pageId];
        return newState;
      });
    }
  };

  return (
    <>
      <div className="pt-14 bg-appGrayBackground ">
         <AdminAppBar />
        <ToastContainer />

        {/* {Heading and Search , add } */}
        <div className="mt-[50px] px-6 flex justify-between">
          <div className="flex flex-col gap-6">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-6">
                <CustomHeading
                  title={`${selectedMedia || 'FaceBook'} Integrations`}
                  isIcon={true}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="px-6 pt-5">
          {/* Connected Account Section */}
          <div className="mb-8">
            <div className="text-lg font-medium text-gray-700 mb-4">Connected Account</div>
            <div className="flex items-center justify-between bg-white rounded-lg p-4 shadow-sm">
              <div className="flex items-center gap-3">
                <FaFacebook className="text-3xl text-blue-500" />
                <span className="font-medium text-gray-900">GL Funnel</span>
              </div>
              <span className="px-3 py-1 bg-green-100 text-green-600 text-sm font-medium rounded-full">
                Connected
              </span>
            </div>
          </div>

          {/* Available Pages Section */}
          <div className="">
            <div className="flex items-center justify-between py-4">
              <div className="text-lg font-medium text-gray-700">
                Available Pages ({pagesData.length})
              </div>
              <button className="w-6 h-6 rounded-full border border-gray-300 flex items-center justify-center">
                <span className="text-gray-400 text-sm">?</span>
              </button>
            </div>

            <div className="space-y-4">
              {pagesData.map((page, index) => (
                <div
                  key={page.id}
                  className="bg-white rounded-lg p-4 shadow-sm border border-gray-100"
                >
                  <div className="flex items-center justify-between">
                    {/* Left side - Page info */}
                    <div className="flex-1">
                      <div className="font-medium text-gray-900 mb-1">
                        {page.pageName}
                      </div>
                    </div>

                    {/* Middle - Lead Source */}
                    <div className="flex items-center gap-4 mx-6">
                      <div className="flex items-center gap-2">
                        <span className="text-sm text-gray-600">Lead Source : {page.leadSourceId ? getLeadSourceNameById(page.leadSourceId) : "Select Lead Source"}</span>
                        <div className="min-w-[200px]">
                          <LeadSourceDropdown
                            onSelect={(selectedItem) => handleLeadSourceUpdate(page, selectedItem)}
                            placeholder={page.leadSourceId ? getLeadSourceNameById(page.leadSourceId) : "Select Lead Source"}
                            selectedLeadSourceId={page.leadSourceId} // Pass selected lead source ID
                            key={`leadsource-${page.id}`} // Simplified key
                            initialValue={page.leadSourceId ? "" : ""} // Always start with empty search
                          />
                        </div>
                      </div>
                    </div>

                    {/* Right side - Toggle and Arrow */}
                    <div className="flex items-center gap-4">
                      <label className="flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          className="sr-only peer"
                          checked={page.isSubscribed}
                          onChange={() => handleToggle(page.pageId)}
                          disabled={loadingPages[page.pageId]} // Disable during loading
                        />
                        <div className={`relative w-10 h-5 rounded-full transition-colors duration-200 ${
                          page.isSubscribed ? 'bg-green-500' : 'bg-red-500'
                        } ${loadingPages[page.pageId] ? 'opacity-50' : ''} after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-5`} />
                        
                        {/* Loading spinner overlay */}
                        {loadingPages[page.pageId] && (
                          <div className="absolute inset-0 flex items-center justify-center">
                            <div className="w-3 h-3 border border-white border-t-transparent rounded-full animate-spin"></div>
                          </div>
                        )}
                      </label>
                      
                      {/* <button 
                        onClick={() => handleFormPageList(page)}
                        className="text-gray-400 hover:text-gray-600"
                        disabled={loadingPages[page.pageId]} // Disable navigation during loading
                      >
                        <MdKeyboardArrowRight className="text-xl" />
                      </button> */}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConnectedPage;
